module.exports = __webpack_public_path__ + "static/media/VOUCHER_WINNER.0d06996f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/VOUCHER_WINNER.png
// module id = 189
// module chunks = 0